import { render, staticRenderFns } from "./VesselDetails.vue?vue&type=template&id=fd636b1a&scoped=true"
import script from "./VesselDetails.vue?vue&type=script&lang=js"
export * from "./VesselDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd636b1a",
  null
  
)

export default component.exports